import { Quote, BadgeCheck } from "lucide-react";

const INK = "#0F1E2E";
const CYAN_DARK = "#1D748F";
const PINK_DARK = "#DE0A87";

const CLIENT_QUOTES = [
  {
    q: "You need the right partner. We chose the right partner with CompliSun, and I honestly don't see bringing in a whole Compliance Department again. With CompliSun, the work gets done, no sacrifices, and far better quality than one would get from most fulltime hires.",
    name: "Pia Thompson",
    title: "CEO · Checkbook",
  },
  {
    q: "Partnering with CompliSun Guardian was instrumental in strengthening our compliance management systems. It significantly reduced both cost and time when implementing marketing audits and securing our lending licenses.",
    name: "Mark Mughabghab",
    title: "CEO · RNPL Credit",
  },
];

export function ClientQuotes() {
  return (
    <section id="clients" className="anchor-target py-10 md:py-14" data-testid="client-quotes-section">
      <span className="gf-eyebrow">What clients say</span>
      <h2 className="gf-h text-3xl md:text-4xl mt-3 max-w-3xl">
        Teams that chose CompliSun <span className="gf-grad-text">don't go back.</span>
      </h2>
      <div className="mt-7 grid grid-cols-1 md:grid-cols-2 gap-4 max-w-5xl">
        {CLIENT_QUOTES.map(({ q, name, title }, i) => (
          <figure key={name} className="gf-card p-6 flex flex-col" data-testid={`client-quote-${i}`}>
            <Quote className="h-5 w-5 mb-3 flex-shrink-0" style={{ color: PINK_DARK, fill: PINK_DARK }} />
            <blockquote className="text-[14px] leading-relaxed flex-1" style={{ color: INK, opacity: 0.8 }}>
              &ldquo;{q}&rdquo;
            </blockquote>
            <figcaption className="mt-4 pt-4 flex items-start gap-2" style={{ borderTop: "1px solid rgba(15,30,46,0.08)" }}>
              <BadgeCheck className="h-4 w-4 mt-0.5 flex-shrink-0" style={{ color: CYAN_DARK }} />
              <div>
                <div className="text-[13px] font-extrabold" style={{ color: INK }}>{name}</div>
                <div className="text-[11.5px]" style={{ color: INK, opacity: 0.55 }}>{title}</div>
              </div>
            </figcaption>
          </figure>
        ))}
      </div>
    </section>
  );
}
